export const axiosHelpers = {
    handleAxiosErrors(error, defaultErrorKey: string = 'key_unprocessable_content'): string[] {
        const backendValidationErrors: string[] = [];

        const response = error?.response;

        if (response?.status === 422) {
            let data = response.data;
            if (data?.errors) {
                data = data.errors;
            }

            for (const prop in data) {

                if (!data.hasOwnProperty(prop)) {
                    continue;
                }

                for (const error of data[prop]) {
                    backendValidationErrors.push(prop + '.' + error);
                }
            }

            return backendValidationErrors;
        }
        backendValidationErrors.push(defaultErrorKey);

        console.error(error);

        return backendValidationErrors;
    },

}